/**
 * Reusable component for editing ResourceLinks
 *
 * NOTE: The Yote _resource assigned to a given ResourceLink is immutable and
 * passed in as a prop to this component.
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { DateTime } from 'luxon';

import displayUtils from '../../../global/utils/displayUtils';

const ProgramResourceLinkTableListItem = ({resourceLink, handleUserEvent}) => {
  return (
    <tr>
      <td className="-resource-icon-col"><i className={displayUtils.getResourceIcon(resourceLink.url)}/></td>
      <td className=" ">
        <a className="-program-resource-link -href" href={resourceLink.downloadUrl ? resourceLink.downloadUrl : resourceLink.url} target="_blank" onClick={handleUserEvent}>{resourceLink.name} <span className="-icon"><i className="far fa-arrow-up-right-from-square"/></span></a>
      </td>
      <td className="-right">{DateTime.fromISO(resourceLink.created).toLocaleString(DateTime.DATE_SHORT)}</td>
      <td className="-right">{DateTime.fromISO(resourceLink.updated).toLocaleString(DateTime.DATE_SHORT)}</td>
    </tr>
  )
}

ProgramResourceLinkTableListItem.propTypes = {
  resourceLink: PropTypes.object.isRequired
  , handleUserEvent: PropTypes.func.isRequired 
}

export default ProgramResourceLinkTableListItem;



// WEBPACK FOOTER //
// modules/resourceLink/components/ProgramResourceLinkTableListItem.js.jsx